import { CSSProperties, FC, PropsWithChildren, useEffect, useState } from "react";
import './index.scss'

interface Props {
  label: string
  styles?: CSSProperties
  childrenType?: 'input' | 'textarea' | 'select'
}

export const FloatingLabel: FC<PropsWithChildren<Props>> = ({
  label,
  styles,
  childrenType = 'input',
  children
}) => {

  return (
    <div
      style={styles}
      className={`floating-label-component type-${childrenType} ${label.length > 0 ? 'up' : ''}`}
    >
      {children}
    </div>
  )
}